import store from '@/store';

export function attr_accessor(stateSelector, setter) {
    return {
        get: () => stateSelector(store.state),
        set(value) { this.$store.commit(setter, value); }
    };
}